export { default, getServerSideProps } from './[tag]';
